import React from 'react';
import { useDispatch } from 'react-redux';
import { useResponsive } from '../../../hooks/useResponsive';
import { popupSlice } from '../../../services/reducers';
import MapModal from '../../../layouts/Modal/MapModal';
import { IAddress } from '../../../types/types';

interface AddressesSectionProps {
  addresses: IAddress[];
  userId?: string;
  activeSection: string
}

const AddressesSection: React.FC<AddressesSectionProps> = ({ addresses, userId, activeSection }) => {
  const dispatch = useDispatch();
  const {
    isMobile,
  } = useResponsive();
  return (
    <section className={`bottom ${isMobile && activeSection !== 'addresses' ? 'hidden-mobile' : ''}`}>
      <div className="section-header">
        <h6 className="dashBoardTitle">آدرس ها</h6>
        <button
          type="button"
          className="btn-add"
          onClick={() => dispatch(popupSlice.middle(<MapModal userId={userId} />))}
        >
          افزودن آدرس
        </button>
      </div>

      <div className={`addresses-container ${isMobile ? 'mobile-addresses' : ''}`}>
        {addresses.length > 0 ? (
          addresses.map(address => (
            <div key={address.id} className={`address-card ${isMobile ? 'mobile-address-card' : 'bottomDiv'}`}>
              <div className="address-content">
                <div className="address-info">
                  <div className="address-header">
                    <i className="mapPin"></i>
                    <h6>{address?.title}</h6>
                  </div>
                  <p className="address-text">
                    {address?.description}
                    <br/>
                    {address?.phoneNumber}
                  </p>
                </div>
                <div className="address-actions">
                  <img src="/img/map.jpg" className="map-photo" alt="Map" />
                  <button
                    type="button"
                    className="edit-address-btn"
                    onClick={() => dispatch(popupSlice.middle(<MapModal userId={userId} address={address} />))}
                  >
                    <i className="edit"></i>
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="no-data-message">
            <p>هیچ آدرسی ثبت نشده است</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default AddressesSection;
